/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import DockIcon from '@mui/icons-material/Dock';

type DockListItemProps = {
  handleDock: () => void;
  closeMenu: () => void;
};

const DockListItem = (props: DockListItemProps) => {
  const { t } = useTranslation();

  const { handleDock, closeMenu } = props;

  const handleClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    closeMenu();
    handleDock();
  };

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>
        <DockIcon color="primary" fontSize="small" />
      </ListItemIcon>
      <ListItemText>{t('buttons.dock_right')}</ListItemText>
    </MenuItem>
  );
};

export default DockListItem;
